import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const boardAttachmentsStyleId = 'wb-v2-board-attachments-theme';

/**
 * Outer chrome mirrors board-table / board-list (inset + framed content well).
 * Inner tile gap stays attachment-specific.
 */
export const boardAttachmentsBridgeStyles = {
  'board-attachments': {
    // Match board-table host: 0 / 16px / 16px (inline = gray top inset)
    '--local-board-attachments-pad-block-start': tokens.spacing.none,
    '--local-board-attachments-pad-inline': tokens.spacing.xl,
    '--local-board-attachments-pad-block-end': tokens.spacing.xl,
    // Framed well (ag-grid outer chrome analogue)
    '--local-board-attachments-well-bg': tokens.color.background.primary,
    '--local-board-attachments-well-border': tokens.color.border.secondary,
    '--local-board-attachments-well-radius': tokens.radius.xl,
    // Inner content padding inside the well (tiles need air; table cells use grid padding)
    '--local-board-attachments-well-pad': tokens.spacing.xl,
    '--local-board-attachments-gap': tokens.spacing.xl,
    '--local-board-attachments-state-color': tokens.color.text.secondary,
    '--local-board-attachments-state-size': tokens.font.size.textSm,
  },
};
